import React, { forwardRef, useContext } from "react"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Form, Input, Modal, notification } from "antd"
import { EditableList } from "../../compnents/list/EditableList"
import { ReturnColumns, ReturnColumnsBranch } from "./columns"
import { unwrapResult } from "@reduxjs/toolkit"
import { RootDispatch } from "../../app/store"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import styles from "./appllication.module.css"
import { ThemeContext } from "../../theme/ThemeContext"
import moment from "moment"
import { DateTimeFormatSimpleOnly } from "../../models/datetime"
import { ProcurementQuery, ReturnBranchQuery, ReturnQuery } from "./Query"
import { Category } from "../../models/category"
import { selectChainId, selectTenantId } from "../../app/applicationSlice"
import {
  getchainInventoryReceiptslist,
  getPurchaseBusinessListFn,
  getRemoveReceiptsFn,
  getReturnPageFn,
} from "./chainSlice"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { traceRoute } from "../../layouts/layoutSlice"
import { DateRangeFieldName, DateRangeType, getDateRange } from "../../compnents/form/DateSelect"

export const ReturnBusinessBranchRef = (props?:{
  activeKey?:any
}) => {
  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const usedStorageRef = React.useRef(false)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({ current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 10,
    recepitsDateStart: storageParams?.recepitsDateStart || timeHead,
    recepitsDateEnd: storageParams?.recepitsDateEnd || timeTail,
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,})

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const [searchVisible, setSearchVisible] = useState(false)

  const [searchParams, setSearchParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [searchPage, setSearchPage] = useState<any>({ items: [], total: 0 })

  const [pageSearchLoading, setPageSearchLoading] = useState(false)


  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])

  const getPageList = () => {
    setPageLoading(true)
    const useStorage =
      !usedStorageRef.current && Object.keys(storageParams || {}).length > 0
    const param = useStorage ? storageParams : params
    usedStorageRef.current = true
    if (useStorage) {
      setParams(param)
    }

    sessionStorage.setItem(
      location.pathname + '_' + props?.activeKey,
      JSON.stringify({ ...param })
    )
    
    dispatch(
      getReturnPageFn({
        ...param,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  return (
    <Col
      style={{
        backgroundColor: theme.pn,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 0px)',
        overflow: 'hidden',
        padding: '10px 15px 0 15px',
      }}
    >
      <ReturnBranchQuery
        loading={pageLoading}
        activeKey={props?.activeKey}
        onValueChange={(v: any) => {
          setParams({
            ...params,
            ...v,
            current: v?.current
              ? v?.current
              : storageParams?.current
              ? storageParams?.current
              : 1,
          })
        }}
      />
      <EditableList
        style={{ flex: 1 }}
        scroll={{ x: '30rem' }}
        loading={pageLoading}
        page={{
          items: page.items,
          current: params.current,
          size: params.size,
          total: page.total,
        }}
        onRow={(r) => ({
          onDoubleClick: () => {
            history.push({
              pathname: '/chainPutList',
              state: {
                where: ['连锁业务', '退货业务'],
                name: '连锁业务',
                backName: tenantId == chainId ? '连锁调拨出库' : '连锁申领业务',
                path:
                  tenantId == chainId
                    ? '/chainTransferOutbound'
                    : '/chainClaimBusiness',
                category: Category.FDTHYW,
                selectId: r.id,
                detail: { ...r },
                approvedUserName: r?.approvedUserName,
              },
            })
          },
        })}
        pageSizeOptions={['10', '20', '50', '100']}
        rowKey={(m: any) => m.id}
        columns={ReturnColumnsBranch(
          params.size * (params.current - 1),
          (action: any, t: any) => {
            switch (action) {
              case 'list':
                setParams({ ...params })
                break
              case 'delete':
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认删除？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    dispatch(getRemoveReceiptsFn(t.id))
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '删除成功',
                        })
                        setParams({ ...params })
                      })
                  },
                })
            }
          },
          Category.CGYW
        )}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size: size || 10 })
        }
        sticky
      />
    </Col>
  )
}

export const ReturnBusinessBranch = forwardRef(ReturnBusinessBranchRef)
